import { useQuery } from "@tanstack/react-query";
import useLocaleQueryFilter from "../../utils/useLocaleQueryFilter";
import { ProductCardType, ResultsResponse } from "./useProducts";
import useJwt from "../../utils/useJwt";

export default function useFavoriteProducts() {
  const jwt = useJwt();
  const localeFilter = useLocaleQueryFilter({ jwt });

  return useQuery<ResultsResponse<ProductCardType[]>, Error>(
    ["favorites/products", localeFilter],
    {
      enabled: !!jwt,
    }
  );
}
